import axios from "axios";
import { host } from "../configuraciones";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

//constantes
const dataInicial = {
  data: {
    data: [],
  },
  dataDescuento: {
    data: [],
  },
  dataAsociado: [],
  tipo: 0,
  catalogoMaguey:[],
};
//types
const OBTENER_CLIENTES_EXITO = "OBTENER_CLIENTES_EXITO";
const OBTENER_DATOS_PREDIO_BY_NUMERO_SOCIO =
  "OBTENER_DATOS_PREDIO_BY_NUMERO_SOCIO";
const OBTENER_DATOS_PREDIO_BY_NOMBRE_PREDIO =
  "OBTENER_DATOS_PREDIO_BY_NOMBRE_PREDIO";
const OBTENER_DATOS_PREDIO_BY_ID_CLIENTE = "OBTENER_DATOS_PREDIO_BY_ID_CLIENTE";

const REGISTRAR_DATOS_PREDIO = "REGISTRAR_DATOS_PREDIO";

const ACTUALIZAR_INSTALACION_BY_ID = "ACTUALIZAR_INSTALACION_BY_ID";
const ACTUALIZAR_DATOS_PREDIO = "ACTUALIZAR_DATOS_PREDIO";
const OBTENER_CLIENTES_EXITO_CONSULTA = 'OBTENER_CLIENTES_EXITO_CONSULTA'
const OBTENER_CLIENTES_PREDIO_EXITO = 'OBTENER_CLIENTES_PREDIO_EXITO'
const OBTENER_DATOS_PREDIO_EXITO = 'OBTENER_DATOS_PREDIO_EXITO'
const OBTENER_CATALOGO_MAGUEY_EXITO = 'OBTENER_CATALOGO_MAGUEY_EXITO'
const OBTENER_TODOS_DESCUENTOS_EXITO = 'OBTENER_TODOS_DESCUENTOS_EXITO'
const OBTENER_CLIENTES_DESCUENTO_EXITO = 'OBTENER_CLIENTES_DESCUENTO_EXITO'
const OBTENER_CLIENTES_ASOCIADO_EXITO = 'OBTENER_CLIENTES_ASOCIADO_EXITO'

export const obtenerTodosLosClientesConDetalle = createAsyncThunk(
  OBTENER_CLIENTES_EXITO,
  async () => {
    try {
      const fullUrl =
        host + `InformacionValida/obtenerTodosLosClientesConDetalle`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const obtenerDatosPredioByNumeroSocio = createAsyncThunk(
  OBTENER_DATOS_PREDIO_BY_NUMERO_SOCIO,
  async (numeroSocio) => {
    try {
      const fullUrl =
        host + `DatosPredio/obtenerDatosPredioByNumeroSocio/${numeroSocio}`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const obtenerDatosPredioByNombrePredio = createAsyncThunk(
  OBTENER_DATOS_PREDIO_BY_NOMBRE_PREDIO,
  async (nombrePredio) => {
    try {
      const fullUrl =
        host + `DatosPredio/obtenerDatosPredioByNombrePredio/${nombrePredio}`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const obtenerDatosPredioByIdCliente = createAsyncThunk(
  OBTENER_DATOS_PREDIO_BY_ID_CLIENTE,
  async (idCliente) => {
    try {
      const fullUrl =
        host + `DatosPredio/obtenerDatosPredioByIdCliente/${idCliente}`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const registroPredioCliente = createAsyncThunk(
  REGISTRAR_DATOS_PREDIO,
  async (data) => {
    try {
      const fullUrl =   host + `InformacionValida/agregarPredioCliente`;
      delete data.idtipoplantacion
      const res = await axios.post(fullUrl, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateInstalacionById = createAsyncThunk(
  ACTUALIZAR_INSTALACION_BY_ID,
  async (data) => {
      try {
        const fullUrl =   host + `InformacionValida/actualizarInstalacionesCliente`;
          //alert(JSON.stringify(data))
          const result = await axios.put(fullUrl, data)
          return result
      } catch (error) {
          console.log(error);
      }
  }
)
export const actualizarPredioCliente = createAsyncThunk(
  ACTUALIZAR_DATOS_PREDIO,
  async (data) => {
    try {
      const fullUrl =   host + `InformacionValida/actualizarEstatusPredioCliente`;
      const res = await axios.put(fullUrl, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const obtenerTodosLosClientesConsulta = createAsyncThunk(
  OBTENER_CLIENTES_EXITO_CONSULTA,
  async () => {
    try {
      const fullUrl = host + `InformacionValida/obtenerTodosLosClientesConsultas`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);
export const obtenerTodosLosDatosPredio = createAsyncThunk(
  OBTENER_CLIENTES_PREDIO_EXITO,
  async () => {
    try {
      const fullUrl = host + `InformacionValida/obtenerTodasDatosMaguey`;
      const res = await axios.get(fullUrl);
      return res.data.data
    } catch (error) {
      console.log(error);
    }
  }
);
export const obtenerDatosPredio = createAsyncThunk(
  OBTENER_DATOS_PREDIO_EXITO,
  async () => {
    try {
      const fullUrl = host + `InformacionValida/obtenerTodasDatosPredio`;
      const res = await axios.get(fullUrl);
      return res.data.data
    } catch (error) {
      console.log(error);
    }
  }
);
export const obtenerCatalogoMaguey = createAsyncThunk(
  OBTENER_CATALOGO_MAGUEY_EXITO,
  async () => {
    try {
      const fullUrl = host + `CatalogoMaguey/obtenerCatalogoMaguey`;
      const res = await axios.get(fullUrl);
      return res.data.data

    } catch (error) {
      console.log(error);
    }
  }
);
export const obtenerTodosDescuentos = createAsyncThunk(
  OBTENER_TODOS_DESCUENTOS_EXITO,
  async () => {
    try {
      const fullUrl = host + `DescuentoMaguey/obtenerTodosDatosDescuento`;
      const res = await axios.get(fullUrl);
      return res.data.data

    } catch (error) {
      console.log(error);
    }
  }
);

export const obtenerTodosLosClientesConDetalleDescuento = createAsyncThunk(
  OBTENER_CLIENTES_DESCUENTO_EXITO,
  async () => {
    try {
      const fullUrl =
        host + `InformacionValida/obtenerTodosLosClientesConDetalle`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);
export const obtenerTodosLosClientesConDetalleParaAsociado = createAsyncThunk(
  OBTENER_CLIENTES_ASOCIADO_EXITO,
  async () => {
    try {
      const fullUrl = host + `InformacionValida/obtenerTodosLosClientesConDetalle`;
      const res = await axios.get(fullUrl);
      return res.data.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const infoValidaSlice = createSlice({
  name: "infoValidaSlice",
  initialState: dataInicial,
  reducers: {},
  extraReducers: {
    [obtenerTodosLosClientesConDetalle.fulfilled]: (state, { payload }) => {
      state.data = payload.data;
    },
    [obtenerTodosLosClientesConDetalleDescuento.fulfilled]: (state, { payload }) => {
      state.dataDescuento = payload.data;
    },
    [obtenerTodosLosClientesConDetalleParaAsociado.fulfilled]: (state, { payload }) => {
      state.dataAsociado = payload;
    },
    [obtenerTodosLosClientesConsulta.fulfilled]: (state, { payload }) => {
      state.data = payload?.data;
    },
    [obtenerDatosPredioByIdCliente.fulfilled]: (state, { payload }) => {
      state.data = payload.data;
    },

    [obtenerDatosPredioByNumeroSocio.fulfilled]: (state, { payload }) => {
      state.data = payload.data;
    },

    [obtenerDatosPredioByNombrePredio.fulfilled]: (state, { payload }) => {
      state.data = payload.data;
    },

    [registroPredioCliente.fulfilled]: (state, { payload }) => {},
    [registroPredioCliente.rejected]: (state, { payload }) => {
      state.error = payload.error;
    },

    [actualizarPredioCliente.fulfilled]: (state, { payload }) => {},
    [actualizarPredioCliente.rejected]: (state, { payload }) => {
      state.error = payload.error;
    },
    [obtenerCatalogoMaguey.fulfilled]: (state, { payload }) => {
      state.catalogoMaguey = payload;
    },
  },
});

export const {} = infoValidaSlice.actions;
export const InformacionValidaReducer = infoValidaSlice.reducer;
